import { render, staticRenderFns } from "./IndividualF.vue?vue&type=template&id=4e00ff86"
import script from "./IndividualF.vue?vue&type=script&lang=js"
export * from "./IndividualF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports